import React, { PropTypes } from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './Rejestracja.css';
import cx from 'classnames';
import GrayPanel from '../../components/GrayPanel';
import _ from 'lodash';
import Modal from 'react-bootstrap/lib/Modal';
import Button from 'react-bootstrap/lib/Button';
import fetch from '../../core/fetch';

const ModalAlert = ({ title, bodyText, disableButton, name, ...props }) =>
<Modal {...props}>
  <Modal.Header className="bg-warning" closeButton>
    <Modal.Title>{title}</Modal.Title>
  </Modal.Header>
  <Modal.Body>
    {bodyText}
    <br /><br />
    {!disableButton ? (
      <Button className="btn btn-warning pull-right" onClick={() => props.onHide(name)}>Zamknij</Button>
    ) : null}
    <br /><br />
  </Modal.Body>
</Modal>;


const FormControl = props => <div className={s.formGroup}>
  <label className={s.label} htmlFor={props.name}>
    {props.label}
  </label>
  {props.isSelect && props.isSelect === true ?
    <select
      className={cx(s.input, props.errors.length > 0 && s.errorInput)}
      id={props.name}
      name={props.name}
      value={props.value}
      onChange={props.onChange}
    >
      {props.options.map((option, i) => <option key={i}>{option}</option>)}
    </select>
  :
    <input
      className={cx(s.input, props.errors.length > 0 && s.errorInput)}
      id={props.name}
      type={props.inputType}
      name={props.name}
      disabled={Object.keys(props).indexOf('disabled') >= 0 ? props.disabled : false}
      value={props.value}
      onChange={props.onChange}
    /> }
  {props.errors.length > 0 &&
    <label className={s.errorLabel} htmlFor={props.name}>
    {props.errors.length === 1 ? props.errors[0] : props.errors.reduce((err, next) => `${next}, ${err}`, '')}
    </label>
  }
</div>;

FormControl.propTypes = {
  name: PropTypes.string,
  inputType: PropTypes.string,
  label: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
  errors: PropTypes.array,
};

const validateLength = (val, min = 0, max = 0) => {
  if (min !== 0) {
    if (val.length < min) return "Za krótka liczba znaków.";
  }
  if (max !== 0) {
    if (val.length > max) return "Za długa liczba znaków";
  }
  return null;
};

const containsSpecialCharacter = (val) => {
  const regex = /[ !@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/g;
  return regex.test(val) ? null : "Hasło powinno zawierać znaki specjalne."
};

const hasUpperLetter = (val) => {
  let hasUpperLetter = false;
  for (const char of val) {
    if (char === char.toUpperCase()) {
      return null;
    }
  }
  return 'Brak dużej litery';
};

// Funkcja 'checkControlSum' sprawdzająca sume kontrolną:
// params:
// wagi: type array
// numer type string
// modulo type number
// output: type bool
const checkControlSum = (wagi, numer, modulo) => {
  let checksum = 0;
  for (let i = 0; i < wagi.length; i += 1) {
    checksum += (parseInt(numer.substring(i, i + 1), 10) * wagi[i]);
  }
  checksum = checksum % modulo;
  if (checksum === 10) checksum = 0; // jeśli wynik z modulo 11 jest 10
  if (parseInt(numer.substring(numer.length - 1, numer.length), 10) !== checksum) {
    return false;
  }
  return true;
};
// const validatePesel = val => {
//   if (val.length !== 11) {
//     return 'Pesel składa się z 11 cyfr';
//   }
//   const digitReg = /^[0-9]{11}$/;
//   if (!digitReg.test(val)) {
//     return 'Pesel musi zawierać tylko cyfry';
//   }
//   const miesStr = val.substring(2, 4);
//   const miesiac = parseInt((val.substring(2, 4)), 10);
//   if ((miesiac > 12 && miesiac < 21) ||
//     (miesiac > 32 && miesiac < 41) ||
//     (miesiac > 52 && miesiac < 61) ||
//     (miesiac > 72 && miesiac < 81) ||
//     (miesiac > 92 && miesiac < 100)) {
//     return 'Nieprawidłowy miesiąc';
//   }
//   const dzien = parseInt((val.substring(4, 6)), 10);
//   if (dzien === 0 || dzien > 31) {
//     return 'Nieprawidłowy dzień';
//   }

//   let rok = val.substring(0, 2);
//   if (miesiac > 80 && miesiac < 93) {
//     rok = parseInt((`18${rok}`), 10);
//   }
//   if (miesiac > 0 && miesiac < 13) {
//     rok = parseInt((`19${rok}`), 10);
//   }
//   if (miesiac > 20 && miesiac < 33) {
//     rok = parseInt((`20${rok}`), 10);
//   }
//   if (miesiac > 40 && miesiac < 53) {
//     rok = parseInt((`21${rok}`), 10);
//   }
//   if (miesiac > 60 && miesiac < 73) {
//     rok = parseInt((`22${rok}`), 10);
//   }

//   // walidacja 30-dnia m-ca
//   if (miesiac % 2 === 0 && dzien === 31) {
//     return 'Nieprawidłowy dzień';
//   }
//   // walidacja lutego
//   if (['02', '22', '42', '62', '82'].includes(miesStr)) {
//     switch (dzien) {
//       case 30:
//         return 'Nieprawidłowy dzień';
//       case 29:
//         // rok przestępny
//         if (!(rok % 4 === 0 && rok % 100 !== 0 || rok % 400 === 0)) {
//           return 'Nieprawidłowy dzień';
//         }
//     }
//   }
//   // sprawdzanie sumy kontrolnej
//   const wagiNaPesel = [9, 7, 3, 1, 9, 7, 3, 1, 9, 7];
//   if (!checkControlSum(wagiNaPesel, val, 10)) {
//     return 'Nieprawidłowy pesel';
//   }
//   return null;
// };

const validateRegon = val => {
  const digitReg = /[^0-9]/g;
  if (digitReg.test(val)) {
    return 'Regon musi zawierać tylko cyfry';
  }
  const wagiNa7 = [2, 3, 4, 5, 6, 7];
  const wagiNa9 = [8, 9, 2, 3, 4, 5, 6, 7];
  const wagiNa14 = [2, 4, 8, 5, 0, 9, 7, 3, 6, 1, 2, 4, 8];

  switch (val.length) {
    case 9:
      // najpierw stare numery niegdyś 7-cyfrowe z dwoma zerami na początku:
      if (parseInt(val.substring(0, 2), 10) === 0) {
        if (!checkControlSum(wagiNa7, val.substring(2, 9), 11)) {
          return 'Nieprawidłowy regon';
        }
        return null;
      }
      // nowe numery:
      if (!checkControlSum(wagiNa9, val, 11)) {
        return 'Nieprawidłowy regon';
      }
      return null;
    case 14:
      // najpierw weryfikacja pierwszych 9 cyfr:
      if (!checkControlSum(wagiNa9, val.substring(0, 9), 11)) {
        return 'Nieprawidłowy regon';
      }
      // teraz weryfikacja całego 14-cyfrowego numeru
      if (!checkControlSum(wagiNa14, val, 11)) {
        return 'Nieprawidłowy regon';
      }
      return null;
    default:
      return 'Regon składa się z 9 bądź 14 cyfr';
  }
};

const validateConfirmPasswd = (val, val2) => {
  if (val2 !== val) {
    return 'Niezgodność haseł';
  }
  return null;
};

const isZipCode = val => {
  const regex = /([00-99]{2})\-([00-99]{3})/g;
  return regex.test(val) ? null : "Nieprawidłowy format kodu pocztowego";
};

const isEmail = val => {
  const regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return regex.test(val) ? null : "Nieprawidłowy adres email";
};

const isNotNull = val => {
  return val.length === 0 ? 'Pole jest wymagane' : null;
};

const formDict = [
  {
    shortName: 'UserName',
    label: 'Nazwa użytkownika*',
    value: '',
    errors: [],
    validators: [{
      validator: validateLength,
      params: {
        min: 5,
      },
    }],
    inputType: 'text',
  },
  {
    shortName: 'Password',
    label: 'Hasło*',
    value: '',
    errors: [],
    validators: [{
      validator: hasUpperLetter,
      params: {},
    }, {
      validator: containsSpecialCharacter,
      params: {},
    }],
    inputType: 'password',
  },
  {
    shortName: 'ConfirmPassword',
    label: 'Potwierdzenie hasła*',
    value: '',
    errors: [],
    validators: [{
      validator: validateConfirmPasswd,
      params: {},
    }],
    inputType: 'password',
  },
  {
    shortName: 'FirstName',
    label: 'Imię*',
    value: '',
    errors: [],
    inputType: 'text',
    validators: [{
      validator: validateLength,
      params: {
        min: 3,
      },
    }],
  },
  {
    shortName: 'LastName',
    label: 'Nazwisko*',
    value: '',
    errors: [],
    inputType: 'text',
    validators: [{
      validator: validateLength,
      params: {
        min: 3,
      },
    }],
  },
  {
    shortName: 'Pesel',
    label: 'PESEL*',
    value: '',
    errors: [],
    inputType: 'text',
    validators: [{
      validator: isNotNull,
      params: {},
    }],
  },
  {
    shortName: 'username',
    label: 'Login*',
    value: '',
    errors: [],
    inputType: 'text',
    validators: [{
      validator: isNotNull,
      params: {},
    }],
  },
  {
    shortName: 'pzEmail',
    label: 'Email EPUAP*',
  },
  {
    shortName: 'pzLogin',
    label: 'Login EPUAP*',
  },
  {
    shortName: 'url',
    label: 'Adres skrytki ePUAP',
    description: {
      title: 'Znajdowanie adresu swojej skrytki na ePUAP',
      href: 'https://www.gov.pl/attachment/cc37dad0-524f-4222-82cb-1fe7aa39c83b'
    }
  },
  {
    shortName: 'e_doreczenia_url',
    label: 'Adres do doręczeń elektronicznych e-Doręczenia',
    description: {
      title: 'Czym są e-Doręczenia?',
      href: 'https://www.gov.pl/web/e-doreczenia'
    }
  },
  // {
  //   shortName: 'Gender',
  //   isSelect: true,
  //   label: 'Pleć*',
  //   options: ['Mężczyzna', 'Kobieta'],
  //   value: 'Mężczyzna',
  //   errors: [],
  //   inputType: 'text',
  //   validators: [],
  // },
  {
    shortName: 'PhoneNumber',
    label: 'Telefon*',
    value: '',
    errors: [],
    inputType: 'text',
    validators: [{
      validator: isNotNull,
      params: {},
    }],
  },
  {
    shortName: 'FaxNumber',
    label: 'Fax',
    value: '',
    errors: [],
    inputType: 'text',
    validators: [],
  },
  {
    shortName: 'FullName',
    label: 'Nazwa firmy/instytucji*',
    value: '',
    errors: [],
    inputType: 'text',
    validators: [{
      validator: isNotNull,
      params: {},
    }],
  },
  {
    shortName: 'Nip',
    label: 'NIP*',
    value: '',
    errors: [],
    inputType: 'text',
    validators: [{
      validator: isNotNull,
      params: {},
    }],
  },
  {
    shortName: 'Regon',
    label: 'REGON',
    value: '',
    errors: [],
    inputType: 'text',
    validators: [{
      validator: validateRegon,
      params: {},
    }],
  },
  {
    shortName: 'AddressCity',
    label: 'Miejscowość*',
    value: '',
    errors: [],
    isSelect: true,
    inputType: 'text',
    validators: [{
      validator: isNotNull,
      params: {},
    }],
  },
  {
    shortName: 'AddressStreet',
    label: 'Ulica',
    value: '',
    errors: [],
    isSelect: true,
    inputType: 'text',
    validators: [{
      validator: isNotNull,
      params: {},
    }],
  },
  {
    shortName: 'AddressFlat',
    label: 'Numer lokalu',
    value: '',
    errors: [],
    inputType: 'text',
    validators: [],
  },
  {
    shortName: 'AddressNumber',
    label: 'Numer budynku*',
    value: '',
    errors: [],
    isSelect: true,
    inputType: 'text',
    validators: [{
      validator: isNotNull,
      params: {},
    }],
  },
  {
    shortName: 'AddressZipCode',
    label: 'Kod pocztowy*',
    value: '',
    errors: [],
    inputType: 'text',
    validators: [{
      validator: isZipCode,
      params: {},
    }, {
      validator: isNotNull,
      params: {},
    }],
  },
  {
    shortName: 'AddressMail',
    label: 'Poczta*',
    value: '',
    errors: [],
    inputType: 'text',
    validators: [{
      validator: isNotNull,
      params: {},
    }],
  },
  {
    shortName: 'AddressDistrict',
    label: 'Gmina*',
    value: '',
    errors: [],
    isSelect: true,
    inputType: 'text',
    validators: [{
      validator: isNotNull,
      params: {
        min: 3,
      },
    }],
  },
  {
    shortName: 'AddressCountry',
    label: 'Kraj*',
    value: '',
    errors: [],
    isSelect: true,
    inputType: 'text',
    validators: [],
  },
  {
    shortName: 'AddressVoivodeship',
    label: 'Województwo*',
    value: '',
    errors: [],
    isSelect: true,
    inputType: 'text',
    validators: [],
  },
  {
    shortName: 'AddressPrecint',
    label: 'Powiat*',
    value: '',
    errors: [],
    isSelect: true,
    inputType: 'text',
    validators: [{
      validator: isNotNull,
      params: {
        min: 5,
      },
    }],
  },
  {
    shortName: 'Email',
    label: 'Email*',
    value: '',
    errors: [],
    inputType: 'text',
    validators: [{
      validator: isEmail,
      params: {},
    }],
  },
];

const personFields = {
  personInfo: ['UserName', 'Password', 'ConfirmPassword'],
  mailAddress: [],
  address: [], // Adres zamieszkania
}

class Rejestracja extends React.Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
  };


  generateAddress = () => {
    const fields = ['AddressCity', 'AddressStreet', 'AddressNumber',
      'AddressFlat', 'AddressZipCode',
      'AddressMail', 'AddressDistrict', 'sdflksdjf',
      'AddressPrecint'];

    const address = {}; // returning object
    fields.forEach(field => {
      const f = _.find(formDict, v => v.shortName === field);
      if (f) address[field] = f;
    });
    return address;
  }

  generateDetails = fields => {
    const address = {}; // returning object
    fields.forEach(field => {
      const f = _.find(formDict, v => v.shortName === field);
      if (this.props.registerData) {
        // If user is logged in with PZ system then set data

        if (f && f.shortName === 'FirstName') {
          const firstName = this.props.registerData.claimedRole['ppZP:PodpisZP'][ 'ppZP:DaneZP']['ppZP:DaneZPOsobyFizycznej']['os:Imie'];
          f.value = firstName;
          f.disabled = true;
        }
        if (f && f.shortName === 'LastName') {
          const lastName = this.props.registerData.claimedRole['ppZP:PodpisZP'][ 'ppZP:DaneZP']['ppZP:DaneZPOsobyFizycznej']['os:Nazwisko']['content'];
          f.value = lastName;
          f.disabled = true;
        }
        if (f && f.shortName === 'Email') {
          const email = this.props.registerData.accountEmailAddress;
          f.value = email;
          f.disabled = true;
        }
        // Pesel is located in 'os:PESEL' property
      }
      if (f) address[field] = f;
    });
    return address;
  }

  generateUserData = () => {
    const fields = ['UserName', 'Password', 'ConfirmPassword'];

    const data = {}; // returning object
    fields.forEach(field => {
      const f = _.find(formDict, v => v.shortName === field);
      if (this.props.registerData && f.shortName === 'UserName') {
        const userName = this.props.registerData.claimedRole['ppZP:PodpisZP'][ 'ppZP:DaneZP']['ppZP:DaneZPOsobyFizycznej'][ 'ppZP:IdKontaUzytkownikaEpuap'];
        f.value = userName;

        f.disabled = true;
      }
      if (f) data[field] = f;
      // if (field === 'ConfirmPassword' && f) {
      //   data[field].validators.push({ validator: this.validateConfirmPasswd, params: {} });
      // }
    });
    return data;
  }

  getPersonFileds = () => {
    const odp = {
      userData: this.generateUserData(),
      // userDetails: this.generateDetails(['FirstName', 'LastName', 'Pesel', 'PhoneNumber', 'FaxNumber', 'BirthDate', 'MobilePhoneNumber', 'Email', 'Gender']),
      userDetails: this.generateDetails(['FirstName', 'LastName',  /*'Pesel',*/ 'PhoneNumber', 'FaxNumber', 'BirthDate', 'Email']),
      mailAddress: this.generateAddress(), // Adres zameldowania
      address: this.generateAddress(), // Adres zamieszkania
    };
    return odp;
  }


  getCompanyFields = () => {
    const odp = {
      companyData: this.generateUserData(),
      companyDetails: this.generateDetails(['CompanyName', 'FullName', 'Nip', 'Regon', 'PhoneNumber', 'FaxNumber', 'Email']),
      mailAddress: this.generateAddress(), // Adres zameldowania
      address: this.generateAddress(), // Adres zamieszkania
    };
    return odp;
  }

  state = {
    type: this.props.registerData ? 'person' : null,
    emailUsed: false, 
    isAgreementSelected: false,
    person: this.getPersonFileds(),
    company: this.getCompanyFields(),
    showError: false,
    errorText: '',
    errorTitle: '',
    hideCallback: null,
  }

  // genderDependsOnPesel = () => {
  //   const isWoman = parseInt(this.state.person.userDetails.Pesel.value.substring(9, 10), 10) % 2 === 0;
  //   const genders = formDict.find(
  //     item => item.shortName === 'Gender',
  //   ).options;
  //   this.setState({
  //     person: {
  //       ...this.state.person,
  //       userDetails: {
  //         ...this.state.person.userDetails,
  //         Gender: {
  //           ...this.state.person.userDetails.Gender,
  //           value: isWoman === true ? genders[1] : genders[0],
  //         },
  //       },
  //     },
  //   });
  // }

  onChange = (e, key, subKey) => {
    let val = e.target.value;
    // FaxNumber  PhoneNumber MobilePhoneNumber
    if (e.target.name === 'FaxNumber' || e.target.name === 'PhoneNumber') {
      if(val.length >=17) {
        val = val.substring(0, 17);
      }
    }
    this.setState({
      [this.state.type]: {
        ...this.state[this.state.type],
        [key]: {
          ...this.state[this.state.type][key],
          [subKey]: {
            ...this.state[this.state.type][key][subKey],
            value: val,
          },
        },
      },
    }, () => {
      const odp = this.state[this.state.type][key][subKey].validators.map(v => {
        if (v.validator === validateConfirmPasswd) {
          return v.validator.apply(null, [val, this.state[this.state.type][key].Password.value]);
        }
        return v.validator.apply(null, [val, ...Object.keys(v.params).map(p => v.params[p])]);
      },
      );
      const test = odp.reduce((prev, curr) => {
        if (curr) {
          return [...prev, curr]
        }
        return prev;
      }, []);

      this.setState({
        [this.state.type]: {
          ...this.state[this.state.type],
          [key]: {
            ...this.state[this.state.type][key],
            [subKey]: {
              ...this.state[this.state.type][key][subKey],
              errors: test,
            },
          },
        },
      }) //, this.genderDependsOnPesel);
    },
    );
  }

  getTitle = () => {
    if (this.state.type) {
      if (this.state.type === 'person' ) {
        return ' jako osoba fizyczna';
      }
      if (this.state.type === 'company' ) {
        return ' jako firma';
      }
    }
    return '';
  }

  onSubmit = e => {
    e.preventDefault();

    let email = '';
    if (this.state.type) {
      if (this.state.type === 'person' ) {
        email = this.state.person.userDetails.Email.value;
      }
      if (this.state.type === 'company' ) {
        email = this.state.company.companyDetails.Email.value;
      }
    }

    const email_url = `${process.env.API_URL}/users/checkemail?email=${email}`
    fetch(email_url, {
      method: 'GET'
    })
    .then(r => {
      if (r.status === 200) {
        this.setState({ showError: true, errorText: 'Wprowadzony adres e-mail jest już używany. Podaj inny adres.', errorTitle: 'Błąd adresu e-mail' });
        return;
      }
    })
    .catch(error => {
      return error;
    });

    if (!this.state.isAgreementSelected) {
      this.setState({ showError: true, errorText: 'Wymagana jest zgoda na przetwarzanie danych osobowych.', errorTitle: 'Błędnie wypełniony formularz' });
      return;
    }

    let hasErrors = [];
    let curState = this.state;

    for (const key of Object.keys(this.state[this.state.type])) {
      for (const subKey of Object.keys(this.state[this.state.type][key])) {
        const odp = this.state[this.state.type][key][subKey].validators.map(v => {
          if (v.validator === validateConfirmPasswd) {
            return v.validator.apply(null, [this.state[this.state.type][key][subKey].value, this.state[this.state.type][key].Password.value]);
          }
          return v.validator.apply(null, [this.state[this.state.type][key][subKey].value, ...Object.keys(v.params).map(p => v.params[p])]);
        });
        const test = odp.reduce((prev, curr) => {
          if (curr) {
            return [...prev, curr];
          }
          return prev;
        }, []);

        if (test && test.length > 0) {
          hasErrors = [ ...hasErrors, ...test ];
        }
        curState = {
          ...curState,
          [curState.type]: {
            ...curState[curState.type],
            [key]: {
              ...curState[curState.type][key],
              [subKey]: {
                ...curState[curState.type][key][subKey],
                errors: test,
              },
            },
          },
        };
      }
    }

    this.setState({ ...curState });
    if (hasErrors.length > 0) {
      const scrollToError = () => {
        let labelWithError;
        [...document.querySelectorAll('label')]
          .filter(lab => lab.textContent.includes(hasErrors[0]))
          .forEach(lab => labelWithError = lab);
        const inputWithError = labelWithError.previousSibling.previousSibling;
        if (inputWithError !== undefined) {
          inputWithError.scrollIntoView();
        }
      };

      scrollToError();
      return;
    }

    const url = '/rejestracja';
    let data = Object.keys(this.state[this.state.type]).reduce((curr, next) => {
      const a = Object.keys(this.state[this.state.type][next]).reduce((c, n) => {
        return { ...c, [n]: this.state[this.state.type][next][n].value };
      }, {});
      return { ...curr, [next]: a };
    }, {});
    data['type'] = this.state.type;
    if (this.props.registerData) {
      data['registerData'] = this.props.registerData;
    }
    fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    })
    .then(r => {
      if (r.status === 200) {
        return r.json();
      }
      throw new Error(r);
    })
    .then(resp => {
      this.setState({ showError: true, errorText: 'Pomyślnie dodano użytkownika', errorTitle: 'Status', hideCallback: () => {
        window.location.href = '/';
      } });
    })
    .catch(err => {
      this.setState({ showError: true, errorText: err, errorTitle: 'Błęd' });
    });
  }

  onHide = () => this.setState({ showError: false }, () => {
    if (this.state.hideCallback) {
      this.state.hideCallback();
    }
  });

  render() {
    const mapKeyToLabel = {
      userData: 'Dane użytkownika',
      userDetails: 'Szczegóły interesanta',
      companyData: 'Dane użytkownika',
      companyDetails: 'Szczegóły interesanta',
      address: this.state.type ? this.state.type === 'person' ? 'Adres do korespondencji' : 'Adres siedziby wnioskodawcy' : '',
      mailAddress: 'Adres zameldowania stałego',
    }
    return (
      <div className={`${s.root} ${s.mobilePadding}`} style={{display: 'block'}}>
        <div className={s.container}>
          <h1 className={s.header}>{`${this.props.title} ${this.getTitle()}`}</h1>
          {this.state.type && <div>
            <hr />
            <form method="post" onSubmit={e => this.onSubmit(e)}>
              {Object.keys(this.state[this.state.type]).map((key, i) =>
                <GrayPanel key={i} title={mapKeyToLabel[key]}>
                  {key === 'address' && <input
                    value="Przepisz dane adresowe"
                    type="button"
                    onClick={() => this.setState({ [this.state.type]: {
                      ...this.state[this.state.type],
                      [key]: { ...this.state[this.state.type].mailAddress },
                    }})}
                    style={{ marginBottom: '15px' }}
                    className="btn btn-default" />}
                  {Object.keys(this.state[this.state.type][key]).map((subKey, j) =>
                    <FormControl
                      key={j}
                      label={this.state[this.state.type][key][subKey].label}
                      name={subKey}
                      isSelect={this.state[this.state.type][key][subKey].isSelect}
                      options={this.state[this.state.type][key][subKey].options}
                      errors={this.state[this.state.type][key][subKey].errors}
                      value={this.state[this.state.type][key][subKey].value}
                      disabled={Object.keys(this.state[this.state.type][key][subKey]).indexOf('disabled') >= 0 ? this.state[this.state.type][key][subKey].disabled : false}
                      inputType={this.state[this.state.type][key][subKey].inputType}
                      onChange={(e) => this.onChange(e, key, subKey)}
                    />,
                  )}
                </GrayPanel>)
              }
              {/* {this.props.registerData ? <div>
                <input style={{display: 'none'}} name="IdZaufanegoProfilu" value={this.props.registerData.claimedRole['ppZP:PodpisZP']['ppZP:DaneZP']['ppZP:DaneZPOsobyFizycznej']['ppZP:IdZaufanegoProfilu']} />
                <input style={{display: 'none'}} name="pzEmail" value={this.props.registerData.accountEmailAddress} />
                <input style={{display: 'none'}} name="pzLogin" value={this.props.registerData.claimedRole['ppZP:PodpisZP'][ 'ppZP:DaneZP']['ppZP:DaneZPOsobyFizycznej'][ 'ppZP:IdKontaUzytkownikaEpuap']} />
                </div> : null} */}
              <div className={s.formGroup}>
                <label className={`checkbox-inline ${s.zgoda}`}>
                  <input type="checkbox" value={this.state.isAgreementSelected} onChange={() => this.setState({ isAgreementSelected: !this.state.isAgreementSelected })} /> &nbsp;&nbsp;&nbsp;
                  Wyrażam zgodę na przetwarzanie moich danych osobowych dla potrzeb niezbędnych dla realizacji procesu obsługi wniosków (zgodnie
                  z Rozporządzenia Parlamentu Europejskiego i Rady (UE) 2016/679 z dnia 27 kwietnia 2016 r. w sprawie ochrony osób fizycznych w związku
                  z przetwarzaniem danych osobowych i w sprawie swobodnego przepływu takich danych oraz uchylenia dyrektywy 95/46/WE oraz Ustawy z dnia
                  10 maja 2018 r. o ochronie danych osobowych (Dz.U. 2018 poz. 1000).</label>
              </div>
              <div className={s.formGroup}>
              * - pola obowiązkowe
              </div>
              <div className={s.formGroup}>
                <button className={s.button} type="submit">
                  Zarejestruj
                </button>
              </div>
            </form>
          </div> }
          {!this.state.type && <div className="row">
            <div className="col-xs-12 col-sm-6">
              <button className={`${s.btnRegister}`} onClick={() => this.setState({ type: 'person' })}>Osoba Fizyczna</button>
            </div>
            <div className="col-xs-12 col-sm-6">
              <button className={`${s.btnRegister}`} onClick={() => this.setState({ type: 'company' })}>Firma</button>
            </div>
          </div>}
        </div>
        <ModalAlert
          title={this.state.errorTitle}
          bodyText={this.state.errorText}
          show={this.state.showError}
          name="errorModal"
          onHide={this.onHide}
        />
      </div>
    );
  }
}
export { formDict, containsSpecialCharacter, hasUpperLetter };
export default withStyles(s)(Rejestracja);



// WEBPACK FOOTER //
// src/routes/rejestracja/Rejestracja.js